export const moduleConstant = {
  apiConstant: `/api/mttrAndMtbfRoute`,
  heading: 'MTTR & MTBF REPORT',
};
